import { setShowModalAction } from "@3gaam/capp/src/store/general";
import { useAppDispatch, useAppSelector } from "@3gaam/capp/src/store/hooks";
import WarningImage from "@3gaam/shared/assets/images/warning-circle.svg";
import Modal from "@3gaam/shared/components/general/modal";
import Image from "@3gaam/shared/components/image";
import { localStorageSet } from "@3gaam/shared/utils/localStorage";
import React, { useCallback, useEffect, useState } from "react";

const VersionManagerModal = () => {
  const [showState, setShowState] = useState(false);
  const [ignorable, setIgnorable] = useState(false);
  const [message, setMessage] = useState("");

  const dispatch = useAppDispatch();
  const modalState = useAppSelector((state) => state.general.modal);

  useEffect(() => {
    if (modalState?.show && modalState?.name === "updateModal") {
      setShowState(true);
      setIgnorable(Boolean(modalState?.data?.ignorable));
      setMessage(String(modalState?.data?.message));
    }
  }, [modalState]);

  const closeModal = useCallback(() => {
    setShowState(false);
    dispatch(setShowModalAction("updateModal", false));
    if (ignorable) {
      let version = modalState?.data?.latestVersion;
      if (!version) {
        return;
      }
      let data = {
        version,
        closedAt: Date.now(),
      };
      localStorageSet("version-manager-c", data);
      return;
    }
    if ("caches" in window) {
      window.caches
        ?.keys()
        .then(function (names) {
          for (let name of names) caches.delete(name);
        })
        .finally(() => {
          window.location.reload();
        });
      return;
    }

    window.location.reload();
  }, [dispatch, ignorable, modalState?.data?.latestVersion]);

  const submitModal = useCallback(() => {
    if ("caches" in window) {
      window.caches
        ?.keys()
        .then(function (names) {
          for (let name of names) caches.delete(name);
        })
        .finally(() => {
          // close modal
          setShowState(false);
          dispatch(setShowModalAction("updateModal", false));
          window.location.reload();
        });
      return;
    }
    // close modal
    setShowState(false);
    dispatch(setShowModalAction("updateModal", false));
    window.location.reload();
  }, [dispatch]);

  return (
    <Modal
      setShow={closeModal}
      showState={showState}
      bodyClassName="py-4 px-3 px-lg-4 pos-rel text-center"
      noCloseBtn={true}
    >
      {ignorable ? (
        <>
          <div className="pt-3">
            <h3 className="font-18 font-weight-semibold mb-2">{message} </h3>
            <p className="text-light-gray font-12 mb-4">
              برای فعال سازی نسخه جدید، دکمه بروزرسانی را بزنید.
            </p>
          </div>
          <div className="d-flex justify-content-center align-items-center mt-4 pt-2">
            <button
              onClick={closeModal}
              className="btn btn-secondary mx-1 py-2"
            >
              انصراف
            </button>
            <button onClick={submitModal} className="btn btn-primary mx-1 py-2">
              بروزرسانی
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="pt-3">
            <div className="mx-auto mb-4 w-60 pb-2">
              <Image src={WarningImage} />
            </div>
            <p className="font-18 font-weight-semibold mb-2">{message} </p>
            <p className="text-light-gray mb-3">
              نسخه جدید به صورت خودکار برای شما فعال میشود.
            </p>
          </div>
          <div className="d-flex justify-content-center mt-4 pt-2">
            <button onClick={submitModal} className="btn btn-primary mx-1 py-2">
              باشه
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default React.memo(VersionManagerModal);
